module.exports = __webpack_public_path__ + "static/phones-8da7248f31d7bcb02b88b919f5cd3c5c.png";